(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-zt-size-selector]').forEach(setup);
  }

  function setup(root) {
    var variantPicker = root.closest('variant-selects, variant-radios');
    if (!variantPicker) return;

    var dataEl = root.querySelector('[data-zt-variant-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = data.variants || [];
    var sizePos = Number(data.sizePos);

    var sizeFieldset = Array.from(
      variantPicker.querySelectorAll('fieldset')
    ).find(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      return (
        legend &&
        legend.textContent.toLowerCase().indexOf('size') !== -1
      );
    });

    if (!sizeFieldset) return;

    var sizeInputs = Array.from(
      sizeFieldset.querySelectorAll('input[type="radio"]')
    );

    if (!sizeInputs.length) return;

    var list = root.querySelector('[data-zt-size-list]');
    var triggerValue = root.querySelector('[data-zt-size-trigger-value]');
    var details = root.querySelector('[data-zt-size-details]');

    if (!list || !triggerValue) return;

    var sizeValues = sizeInputs.map(function (input) {
      return input.value;
    });

    function getCurrentSelections() {
      var groups = Array.from(
        variantPicker.querySelectorAll(
          'fieldset, .product-form__input--dropdown'
        )
      );

      return groups.map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;

        var select = group.querySelector('select');
        if (select) return select.value;

        return null;
      });
    }

    function findVariant(sizeValue) {
      var selections = getCurrentSelections();
      selections[sizePos] = sizeValue;

      return variants.find(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];

        return opts.every(function (value, index) {
          return selections[index] == null || value === selections[index];
        });
      });
    }

    function getStatus(variant) {
      if (variant && Number(variant.inventory_quantity) > 0) {
        return 'IN STOCK';
      }

      return 'MADE TO ORDER';
    }

    function render() {
      var currentInput = sizeFieldset.querySelector(
        'input[type="radio"]:checked'
      );

      var currentSize = currentInput
        ? currentInput.value
        : triggerValue.textContent.trim();

      triggerValue.textContent = currentSize;

      list.innerHTML = '';

      sizeValues.forEach(function (size) {
        var variant = findVariant(size);
        var status = getStatus(variant);

        var li = document.createElement('li');
        li.className = 'zt-size-item';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'zt-size-option';

        if (size === currentSize) {
          button.classList.add('is-selected');
        }

        var sizeText = document.createElement('span');
        sizeText.className = 'zt-size-option-name';
        sizeText.textContent = size;

        var statusText = document.createElement('span');
        statusText.className =
          'zt-size-option-status ' +
          (status === 'IN STOCK' ? 'is-in-stock' : 'is-made-to-order');

        statusText.textContent = status;

        button.appendChild(sizeText);
        button.appendChild(statusText);

        button.addEventListener('click', function () {
          var nativeInput = sizeInputs.find(function (input) {
            return input.value === size;
          });

          if (nativeInput) {
            nativeInput.click();
          }

          triggerValue.textContent = size;

          if (details) {
            details.removeAttribute('open');
          }

          setTimeout(render, 50);
        });

        li.appendChild(button);
        list.appendChild(li);
      });
    }

    variantPicker.addEventListener('change', function () {
      setTimeout(render, 50);
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();